export { default } from './Synonyms'
